import { Component, Input } from '@angular/core';
import { Question } from '../question';
import { Indicators } from '../indicators.interface';

@Component({
	selector: 'app-question',
	templateUrl: './question.component.html',
	styleUrls: ['./question.component.scss']
})
export class QuestionComponent {
	@Input() question: Question;
	@Input() indicators: Indicators;

	constructor() { }
}
